import asyncComponent from "../component/asyncComponent";

export default [
  {
    title: "app介绍",
    name: "app-introduced",
    route: "/app-introduced",
    component: asyncComponent(() => import("../pages/app-introduced")),
  },
  {
    title: "隐私政策",
    name: "privacy-agreement",
    route: "/privacy-agreement",
    component: asyncComponent(() => import("../pages/privacy-agreement")),
  },
  {
    title: "服务协议",
    name: "service-agreement",
    route: "/service-agreement",
    component: asyncComponent(() => import("../pages/service-agreement")),
  },
  {
    title: "邀请注册",
    name: "invitation-register",
    route: "/invitation-register/:invitationCode",
    component: asyncComponent(() => import("../pages/invitation-register")),
  },
  {
    title: "app下载链接",
    name: "app-download",
    route: "/app-download",
    component: asyncComponent(() => import("../pages/app-download")),
  },
  {
    title: "跳转微信小程序瞳景充电站充值中心",
    name: "wx-link-charge-card-top-up-center",
    route: "/wx-link-charge-card-top-up-center",
    component: asyncComponent(() =>
      import("../pages/wx-link-charge-card-top-up-center")
    ),
  },
  {
    title: "物业、停车缴费",
    name: "payment-code",
    route: "/payment-code",
    component: asyncComponent(() => import("../pages/payment-code")),
  },
  {
    title: "物业、停车缴费支付页面",
    name: "payment-code-pay",
    route: "/payment-code/pay",
    component: asyncComponent(() => import("../pages/payment-code/pay")),
  },
];
